import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  input,
  computed,
  afterNextRender,
  ElementRef,
  ViewChild,
  inject,
  HostListener,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Image, ImageComponent, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { DOCUMENT } from '@angular/common';
import { YoutubeComponent } from 'src/app/standalone/components/youtube/youtube.component';

@Component({
  selector: 'app-event-header',
  standalone: true,
  imports: [ImageComponent, YoutubeComponent, ResizeHtmlImagesPipe, StripEmbedPipe, SafePipe],
  templateUrl: './event-header.component.html',
  styleUrl: './event-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventHeaderComponent {
  title = input<string>();
  titleSmall = input<string>();
  subTitle = input<string | null>();
  mobileSubTitleSuffix = input<string | null>();
  youtubeUrl = input<string | null>();
  intro = input<string | null>();
  image = input<Image | null>();
  eventLabel = input<string | null>();

  hasMedia = computed(() => this.image()?.url || this.youtubeUrl());

  cleanIntro = computed(() => {
    const intro = this.intro();

    // remove all <p><br></p> from intro
    return intro?.replace(/<p><br><\/p>/g, '');
  });

  private document = inject(DOCUMENT);
  @ViewChild('contentbelow') contentbelow?: ElementRef;
  @ViewChild('header') header?: ElementRef;

  constructor() {
    afterNextRender(() => {
      this.setContentHeightVar();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setContentHeightVar();
  }

  setContentHeightVar() {
    this.header?.nativeElement.style.setProperty(
      '--content-below-height',
      `${this.contentbelow?.nativeElement?.getBoundingClientRect()?.height || 0}px`
    );
  }
}
